import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'app-unauthorized',
    templateUrl: './unauthorized.component.html',
    styleUrls: ['./unauthorized.component.scss'],
    standalone: false
})
export class UnauthorizedComponent {
  constructor(private router: Router) {}

  goBack(): void {
    // Back to the launchpad, which only shows modules the user can open.
    this.router.navigate(['/']);
  }
}
